import { Interest, UserDetailsType, UserID, UserPhoneEmail } from "../../../../types";
import { getFullName } from "../../../utils";
import { isLocalHost } from "../../../utils/isLocalHost";
import api from "../../api";
import { serverPath } from "../../config";

export const getMyUserDetails = () => api.get<UserDetailsType>(serverPath.myUserDetails);

export const saveMyProfile = (userProfile: Partial<UserDetailsType>) => api.put(serverPath.saveProfile, userProfile);

export const getUserDetails = (userId: UserID) =>
  api.get<UserDetailsType>(`${serverPath.getUserDetails}?userId=${userId}`).then(({ data }) => {
    const withFullName: UserDetailsType = {
      ...data,
      fullname: getFullName(data),
    };

    return withFullName;
  });

export const getPhoneEmail = () => api.get<UserPhoneEmail>(serverPath.getPhoneEmail);

export const updatePhoneEmail = (phoneNumber: string, email: string) =>
  api.post(serverPath.updatePhoneEmail, { phoneNumber, email });

export const uploadPicture = (file: Blob) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post(serverPath.uploadPicture, formData);
};

export const deactivateAccount = () => api.post(serverPath.deactivateAccount);

export const getInterests = () => api.get<Interest[]>(serverPath.getInterests);

export const isActiveAccount = () => api.get<boolean>(serverPath.isActiveAccount);

type FbEvent = "SCHEDULE" | "START_TRIAL" | "LEAD" | "ADD_TO_WISH_LIST" | "COMPLETE_REGISTRATION";

export const sendFbEvent = (event: FbEvent, userId: number) => api.post(serverPath.sendFbEvent, { event, userId });

export const getAppVersion = async () => {
  if (!isLocalHost || window.location.href.includes(":8080")) {
    const response = await fetch("/meta.json");
    const data = await response.json();

    if (data.version) {
      return data.version;
    }
  }

  return undefined;
};
